import * as React from "react";
import Dispatcher from "../../Dispatcher";
import LoginStore from "../login/stores/LoginStore";
import TokenView from "./views/TokenView";
import { Container } from "flux/utils";

interface IState
{
    token?: string;
}

class TokenContainer extends React.Component<{}, IState>
{
    public render()
    {
        return <TokenView {...this.state} />;
    }

    private onTokenClick(evt)
    {
        evt.target.focus();
        evt.target.select();
    }

    public static getStores()
    {
        return [
            LoginStore
        ];
    }

    public static calculateState(prevState)
    {
        const loginLoader = LoginStore.getState().getLoadObject();
        if (!loginLoader.hasValue())
        {
            return {};
        }

        return { token: loginLoader.getValueEnforcing().token };
    }

    private static revokeToken(username: string, password: string)
    {
        Dispatcher.dispatch({
            type: "login/revoke-token",
            username,
            pwd: password
        });
    }
}

export default Container.create(TokenContainer);
